import { render } from "./LeadsCount.vue?vue&type=template&id=f5fb1f1e"
import script from "./LeadsCount.vue?vue&type=script&lang=js"
export * from "./LeadsCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__